import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestion } from "@fortawesome/free-solid-svg-icons";
import "./Tooltip.css";

const Tooltip = ({ description, content }) => {
  const text = description || content;
  return (
    <span
      className="tooltip-wrapper"
      tabIndex={0}
      aria-haspopup="true"
      aria-expanded="false"
    >
      <span className="tooltip-icon" aria-hidden="true">
        <FontAwesomeIcon icon={faQuestion} />
      </span>

      <div
        role="tooltip"
        className="tooltip-text"
        id="tooltip-content"
      >
        <p id="tooltip-description">{text}</p>
      </div>
    </span>

  );
};

export default Tooltip;
